














































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Helpers
 */
import { getFullName } from "@/utils/users-helpers";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import accountsAPI, { AccountResponseModel, CreditRequestModel } from "@/api/accounts";



/**
 * Composant de fenêtre modale de crédit de compte.
 */
@Component({
    mixins: [mixinsAPI]
})
export default class CreditDialog extends Vue {
    $refs!: {
        modal: Dialog
    };

    /** Injections */
    getFullName = getFullName;


    /** VueX - Snackbar */
    @Action('openInfo', { namespace: 'snackbar' })
    openInfo: any;
    @Action('openError', { namespace: 'snackbar' })
    openError: any;

    /** Attributs */
    accountToCredit: AccountResponseModel | null = null;
    payload = new CreditRequestModel();
    isLoading = false;
    payModul = 1;
    PzForm = "";

    /** Méthodes */
    async open(id: number) {
        this.accountToCredit = await accountsAPI.getOne(id);

        this.payload = new CreditRequestModel();
        this.payload.accountToCreditID = id;
        this.$refs.modal.open();
    }

    close() {
       this.PzForm = "";
        this.$refs.modal.close();
    }

    async handleSubmit() {
        this.isLoading = true;

        this.payModul = await accountsAPI.getPaymentModul();
        if (this.payModul == 0) {
            //ATOS
            try {
                await accountsAPI.credit(this.payload);
            }
            catch (ex) {
                (this as any).handleAPIError(ex);
                this.isLoading = false;
            }
        } else {
            try {
                this.PzForm = await accountsAPI.getPayzenForm(this.payload);
                this.isLoading = false;
                //console.log(this.PzForm);
             //   this.Page.Controls.Add(new LiteralControl(this.PzForm));
            // this.contentContainer.load(this.PzForm);
            // var document: Document;
            // document.getElementById("PayerCB").click();
            }
            catch (ex) {
                (this as any).handleAPIError(ex);
                this.isLoading = false;
            }
        }


        //try {

        //    await accountsAPI.credit(this.payload);

        //}
        //catch (ex) {
        //    (this as any).handleAPIError(ex);
        //    this.isLoading = false;
        //}

    }

    onlyForCurrency($event: any) {
        // console.log($event.keyCode); //keyCodes value
        this.PzForm = "";
        const keyCode = ($event.keyCode ? $event.keyCode : $event.which);

        if (keyCode === 13) {
            return;
        }

        const amount = this.payload.amount;

        // if(keyCode == 44){
        // 	keyCode = 46;
        // }

        // only allow number and one dot
        if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || amount.toString().indexOf('.') !== -1)) { // 46 is dot // 188 is comma
            $event.preventDefault();
        }

        // restrict to 2 decimal places
        if (amount != null && amount.toString().indexOf(".") > -1 && (amount.toString().split('.')[1].length > 1)) {
            $event.preventDefault();
        }

        // if(amount != null){
        // 	this.payload.amount = this.payload.amount.replace(',', '.');
        // }

    }
}
